import React from 'react';
import { Button } from './ui/Button';
export function Header() {
  return <header className="fixed top-0 z-50 w-full py-6 px-6 md:px-12 bg-white border-b border-gray-200" data-id="element-55">
      <div className="flex justify-between items-center max-w-7xl mx-auto" data-id="element-56">
        {/* Logo and tagline */}
        <div className="flex items-center gap-3" data-id="element-57">
          <img src="https://cdn.magicpatterns.com/uploads/vLvtxNrnCJQbPJ7Dg5FWPw/PH_logo.jpg" alt="ePluribus Health Logo" className="h-10 w-auto" data-id="element-58" />
          <div className="hidden md:flex items-center gap-1" data-id="element-59">
            <span className="text-gray-300" data-id="element-60">|</span>
            <span className="text-[#2F5890] font-bold text-base" data-id="element-61">
              AI-powered biobank discovery
            </span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex items-center gap-6" data-id="element-62">
          <a href="#unum" className="hidden md:flex items-center gap-1 text-base font-bold text-[#2F5890] hover:text-[#5992D2] transition-colors" data-id="element-63">
            <span className="text-[#A1DA52] text-[24px]" data-id="element-64">▸</span>
            Unum
          </a>
          <a href="#about" className="hidden md:flex items-center gap-1 text-base font-bold text-[#2F5890] hover:text-[#5992D2] transition-colors" data-id="element-65">
            <span className="text-[#A1DA52] text-[24px]" data-id="element-66">▸</span>
            About
          </a>
          <a href="#contact" className="hidden md:flex items-center gap-1 text-base font-bold text-[#2F5890] hover:text-[#5992D2] transition-colors" data-id="element-67">
            <span className="text-[#A1DA52] text-[24px]" data-id="element-68">▸</span>
            Contact
          </a>

          <Button variant="primary" size="md" className="bg-[#A1DA52] hover:bg-[#80BA32] text-[#2F5890] font-semibold" data-id="element-69">
            Investor Download
          </Button>

          <Button variant="secondary" size="md" className="border-2 border-[#2F5890] text-[#2F5890] hover:bg-[#2F5890] hover:text-white font-semibold" data-id="element-70">
            Request Demo
          </Button>
        </nav>
      </div>
    </header>;
}